<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <button v-if="!showNewManufacturer" @click="addManufacturer(false)" class="btn btn-outline-info">Добавить
          производителя
        </button>
        <form @submit.prevent="addManufacturer(true)">
          <div v-if="showNewManufacturer">
            <div class="flex flex_gap">
              <div class="">
                <label>Название производителя</label>
                <input required type="text" v-model="newManufacturer.title" class="form-control">
              </div>
              <div class="flex-grow-1">
                <label>Короткое описание</label>
                <input type="text" v-model="newManufacturer.text" class="form-control">
              </div>
            </div>
            <div class="mt-1 flex">
              <div class="flex-grow-1 pr-2">
                <label>Телефоны</label>
                <button @click="addPhone()" type="button" class="btn btn-outline-info btn-xs">добавить телефон</button>
                <div v-for="(p,i) in newManufacturer.data.phones" :key="i" class="input-group">
                  <input type="text" placeholder="номер" v-model="p.phone" class="form-control">
                  <input type="text" placeholder="комментарий" v-model="p.comment" class="form-control">
                  <button @click="addPhone(i)" type="button" class="btn btn-outline-danger"><i
                    class="icon-fa icon-fa-remove"/>
                  </button>
                </div>
              </div>
              <div class="flex-grow-1">
                <label>Комментарий</label>
                <textarea class="form-control" v-model="newManufacturer.data.comment"
                          placeholder="Комментарии производителя..." rows="3"/>
              </div>
            </div>
            <div class="text-right mt-1">
              <LoadingButton
                title="Сохранить"
                className="btn btn-success"
                type="submit"
                :onClick="() => {}"
                :loading="saveLoading"
                color="white"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="card" v-if="records">
      <div class="card-body">
        <table class="table mt-1 table-sm table-hover">
          <thead>
          <tr>
            <th></th>
            <th>Название</th>
            <th>телефоны</th>
            <th>комментарий</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(r,i) in records" :key="i">
            <td>{{ i + 1 }}</td>
            <td>
              <p>{{ r.title }}</p>
              <p class="text-muted" v-if="r.text">{{ r.text }}</p>
            </td>
            <td>
              <div v-for="p in r.data.phones" class="border-bottom">
                <p>{{ p.phone }}</p>
                <p v-if="p.comment" class="text-muted">{{ p.comment }}</p>
              </div>

            </td>
            <td>{{ r.data.comment }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import LoadingButton from "@/components/buttons/LoadingButton.vue";

export default {
  components: {LoadingButton},
  title: 'Производители',
  data() {
    return {
      loading: false,
      saveLoading: false,
      records: null,
      showNewManufacturer: false,
      newEmptyManufacturer: {
        data: {
          phones: [{phone: '', comment: ''}],
          comment: '',
        }
      },
      newManufacturer: null,
    }
  },
  computed: {
    $AllCountries() {
      return this.$store.getters['platform/countries']
    },
  },
  created() {
    this.getRecords();
  },
  methods: {
    addPhone(index = null) {
      if (index !== null) {
        delete this.newManufacturer.data.phones[index];
        this.newManufacturer.data.phones = this.newManufacturer.data.phones.filter((p) => p);
        return;
      }
      this.newManufacturer.data.phones.push({
        phone: '',
        comment: ''
      })
    },
    async addManufacturer(save = false) {
      if (!save) {
        this.newManufacturer = JSON.parse(JSON.stringify(this.newEmptyManufacturer));
        this.showNewManufacturer = true;
        return;
      }
      this.saveLoading = true;
      const {data} = await api.post('/new/nomenclature/manufacturer', {
        manufacturer: this.newManufacturer
      })
      if (data.success) {
        toastr['success'](data.message || 'сохранено', 'Успешно')
        this.newManufacturer = null;
        this.showNewManufacturer = false;
        await this.getRecords();
      } else {
        toastr['warning'](data.message || 'ошибка сервера', 'Неуспешно')
      }
      this.saveLoading = false;
    },
    async getRecords() {
      this.loading = true;
      const {data} = await api.index('/new/nomenclature/manufacturer');
      if (data.success) {
        this.records = data.records;
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
.flex_gap {
  gap: 5px;
}
</style>
